/*
 * @Author: qinqianwen
 * @Date: 2020-08-14 18:37:40
 * @LastEditTime: 2020-08-24 15:43:57
 * @LastEditors: Please set LastEditors
 * @Description: 设备管理Api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\equipManage.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//获取设备管理页面表格数据
export function fetchEquipData(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/findEquipPage`,
    method: "post",
    data
  });
}
//绑定设备
export function BindingEquipment(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/bindEquip`,
    method: "post",
    data
  });
}
//解绑设备
export function unBindingEquipment(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/unBindEquip`,
    method: "get",
    params
  });
}
//查看绑定记录
export function fetchBindingLog(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/bindLogPage`,
    method: "post",
    data
  });
}
//检查当前用户是否被授权过1.0平台
export function checkIsAuthorize() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/checkAuthorize`,
    method: "get"
  });
}
//登录授权1.0平台
export function loginAndAuthorize(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/authorize`,
    method: "post",
    data
  });
}
//已同步设备查询
export function fetchSyncEquip(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/findEquipSyncPage`,
    method: "post",
    data
  });
}
//未同步设备查询
export function fetchUnSyncEquip(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/findEquipUnSyncPage`,
    method: "post",
    data
  });
}
//将1.0同步到3.0
export function syncEquip(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/saveEquip`,
    method: "post",
    data
  });
}
//取消已同步设备
export function cancelSyncEquip(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/deleteEquipBatch`,
    method: "post",
    data
  });
}
//获取设备类型下拉数据
export function fetchEquipTypeList() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/findEquipTypeList`,
    method: "get"
  });
}
//获取设备来源下拉数据
export function getEquipSourceList() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/findEquipSource`,
    method: "get"
  });
}
//获取车辆下拉树数据源
export function getVehicleTreeList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getOrgVehicleTree`,
    method: "get"
  });
}
//导出设备信息
export function exportEquipInfo(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/equip/export`,
    method: "post",
    data
  });
}
